import store from "../store";

export default function isSplash({ next, router }) {
  const isSplash = store.state.app.isSplash;
  console.log(isSplash)
  if (!isSplash) {
    return next();
  } 
  return next({name:'SplashScreen'});
}